module.exports = __webpack_public_path__ + "img/dsshlkj.fd16a85d.jpg";